import React, { Component } from 'react';
import Up from '../../../../../Images/Daikin_Images/image/ShutterUp.png';
import Down from '../../../../../Images/Daikin_Images/image/ShutterDown.png';

export default class Shutter_On_Off extends Component {
	constructor(props) {
		super(props);
	}

	render() {

		let icon = null;
		if (this.props.action === 'open') {
			icon = Up;
		} else {
			icon = Down;
		}
		return (
			<div id='shutter_on_off' style={this.props.style}>
				<div>
					<img src={icon} style={{ width: 40 }} />
				</div>
				<div>
					<span>{this.props.receiver.getString(this.props.action)}</span>
				</div>
			</div>
		)
	}
}